import FamilyPage from "../../../../pages/PhotoPages/FamilyPage/FamilyPage";
import BirthdayPage from "../../../../pages/PhotoPages/BirthdayPage/BirthdayPage";
import KidsPage from "../../../../pages/PhotoPages/KidsPage/KidsPage";
import CristPage from "../../../../pages/PhotoPages/ChristPage/ChristPage";
import DaughterPage from "../../../../pages/PhotoPages/DaughterPage/DaughterPage";
import LoveStoryPage from "../../../../pages/PhotoPages/LoveStoryPage/LoveStoryPage";
import PregnancyPage from "../../../../pages/PhotoPages/PregnancyPage/PregnancyPage";
import NewbornPage from "../../../../pages/PhotoPages/NewbornPage/NewbornPage";
import NewYearPage from "../../../../pages/PhotoPages/NewYearPage/NewYearPage";
import WeddingPage from "../../../../pages/PhotoPages/WeddingPage/WeddingPage";
import WinterPage from "../../../../pages/PhotoPages/WinterPage/WinterPage";
import WomanPage from "../../../../pages/PhotoPages/WomanPage/WomanPage";

import { getRouteBirthday, getRouteChrist, getRouteDaughter, getRouteFamily, getRouteKids, getRouteLoveStory, getRouteNewYear, getRouteNewborn, getRoutePregnancy, getRouteWedding, getRouteWinter, getRouteWoman } from "./helpers";

const routeConfigePages = {
    family: {
        path: getRouteFamily(),
        element: <FamilyPage/>,
        
    },
    kids: {
        path: getRouteKids(),
        element: <KidsPage/>,   
     
    },
    birthday: {
        path: getRouteBirthday(),
        element: <BirthdayPage/>, 
          
    },
    christ: {
        path: getRouteChrist(),
        element: <CristPage/>,  
       
    },
    daughter: {
        path: getRouteDaughter(),
        element: <DaughterPage/>,
           
    },
    loveStory: {
        path: getRouteLoveStory(),
        element: <LoveStoryPage/>,
          
    },
    newborn: {
        path: getRouteNewborn(),
        element: <NewbornPage/>, 
       
    },
    newyear: {
        path: getRouteNewYear(),
        element: <NewYearPage/>, 
        
    },
    pregnancy: {
        path: getRoutePregnancy(),
        element: <PregnancyPage/>, 
       
    },
    wedding: {
        path: getRouteWedding(),
        element: <WeddingPage/>, 
     
    },
    winter: {
        path: getRouteWinter(),
        element: <WinterPage/>,
         
    },
    woman: {
        path: getRouteWoman(),
        element: <WomanPage/>,
          
    },

}

export default routeConfigePages;